import { render, staticRenderFns } from "./FaqsSingle.vue?vue&type=template&id=42bf767e"
import script from "./FaqsSingle.vue?vue&type=script&lang=js"
export * from "./FaqsSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports